<div>
    <ntv-popover #playlistContentPopover (shown)="onShow.emit()" (hidden)="onHide.emit()">
        <div class="popover">
            @for (action of playlistActions; track action) {
                <div class="popover__item">
                    <span>{{ action.label }}</span>
                </div>
            }
        </div>
    </ntv-popover>
</div>
